(function () {
  function init() {
    if (window.KSNativeCartDrawer || !window.theme || !theme.settings ||
        theme.settings.cartType !== 'drawer' || typeof theme.CartDrawer !== 'function' ||
        document.body.classList.contains('template-cart') ||
        document.querySelector('[data-section-type="header"]') ||
        !document.getElementById('CartDrawer') || !document.getElementById('CartDrawerForm')) return;
    window.KSNativeCartDrawer = new theme.CartDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('load', init, { once: true });
})();

/* Preserve the storefront position when the native cart drawer closes. */
(function () {
  'use strict';
  if (window.KSCartDrawerScrollGuard) return;

  const drawer = document.getElementById('CartDrawer');
  if (!drawer || !window.MutationObserver) return;

  let wasOpen = drawer.classList.contains('drawer--is-open');
  let savedPosition = wasOpen ? { x: window.scrollX, y: window.scrollY } : null;
  let lateRestoreTimer = null;

  function drawerIsOpen() {
    return drawer.classList.contains('drawer--is-open');
  }

  function cancelLateRestore() {
    if (lateRestoreTimer !== null) window.clearTimeout(lateRestoreTimer);
    lateRestoreTimer = null;
    window.removeEventListener('pointerdown', cancelLateRestore, true);
    window.removeEventListener('touchstart', cancelLateRestore, true);
    window.removeEventListener('wheel', cancelLateRestore, true);
    window.removeEventListener('keydown', cancelLateRestore, true);
  }

  function restore(position) {
    if (!position || drawerIsOpen()) return;
    if (Math.abs(window.scrollX - position.x) > 1 || Math.abs(window.scrollY - position.y) > 1) {
      window.scrollTo({ left: position.x, top: position.y, behavior: 'auto' });
    }
  }

  function afterClose(position) {
    window.requestAnimationFrame(function () { restore(position); });

    cancelLateRestore();
    window.addEventListener('pointerdown', cancelLateRestore, true);
    window.addEventListener('touchstart', cancelLateRestore, true);
    window.addEventListener('wheel', cancelLateRestore, true);
    window.addEventListener('keydown', cancelLateRestore, true);
    lateRestoreTimer = window.setTimeout(function () {
      lateRestoreTimer = null;
      restore(position);
      cancelLateRestore();
    }, 550);
  }

  const observer = new MutationObserver(function () {
    const isOpen = drawerIsOpen();
    if (isOpen && !wasOpen) {
      cancelLateRestore();
      savedPosition = { x: window.scrollX, y: window.scrollY };
    } else if (!isOpen && wasOpen) {
      const position = savedPosition;
      savedPosition = null;
      afterClose(position);
    }
    wasOpen = isOpen;
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  window.KSCartDrawerScrollGuard = { observer: observer, cancel: cancelLateRestore };
})();

